/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import moment from "moment";
import { useEffect } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import useEquiposRadarAPI, { Equipo } from "./useEquiposAPI";


export default () => {
    const api = useEquiposRadarAPI();
    const createPage = "/equipos/guardar"
    const editPage = "/equipos/guardar/{Id}"

    const [nombreFilterForm] = Form.useForm();
    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ? `contains(Nombre,'${filters!.Nombre![0]}')` : "",

        ];
    }


    useEffect(() => {

    }, []);

    return (
        <MainLayout>
            <DataTable<Equipo, Equipo>
                list={(query)=>api.list({...query,...{$expand:["ConfiguracionProduccion($expand=UnidadProduccion)"]}})}
                delete={api.delete}
                createAction={{
                    label: "Agregar equipo",
                    path: createPage
                }}
                deleteMultipleAction
                defaultSortOrder={"Nombre desc"}
                selectionType='checkbox'
                title={"Equipos"}
                generateFilters={generateFilters}
                editItemAction={editPage}
                deleteItemAction
                deleteItemActionConfirmMessage={(item) => `¿Eliminar a ${item.Nombre}?`}
                defaultPageSize={25}

            >
                <Table.Column<Equipo>
                    width={`5%`}
                    title="ID"
                    dataIndex={"Id"}
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<Equipo>
                    width={`30%`}
                    title="Nombre"
                    dataIndex={"Nombre"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<Equipo>>
                            save={api.save}
                            id={record.Id}
                            render={(value) => value.Nombre!}
                            formValue={{ Nombre: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Nombre"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Nombre...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<Equipo>
                    width={`15%`}
                    title="Marca y modelo"
                    dataIndex={"Marca"}
                    render={(value, record) => `${record.Marca} ${record.Modelo}`}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}

                />


                <Table.Column<Equipo>
                    width={`15%`}
                    title="Unidad de producción"
                    dataIndex={"ConfiguracionProduccion"}
                    render={(value, record) => `${record.ConfiguracionProduccion.UnidadProduccion.Nombre}`}

                />

                <Table.Column
                    width={`10%`}
                    title="Fecha verificación"
                    dataIndex={"FechaVerificacion"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                    render={(value: string, record, index) => value ? moment(value).format("DD-MM-yyyy") : '-'}

                />

                <Table.Column
                    width={`10%`}
                    title="Fecha vencimiento verificación"
                    dataIndex={"FechaVencimientoVerificacion"}
                    sorter
                    sortDirections={["ascend", "descend", "ascend"]}
                    render={(value: string, record, index) => value ? moment(value).format("DD-MM-yyyy") : '-'}
                /*filterDropdown={(props)=>{
                    return (
                        <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                            <Form.Item name={"Fecha homologación"} style={{marginBottom:10}}>
                                <Input placeholder='Fecha homologación...'></Input>
                            </Form.Item>
                        </DataFilter>
                    );
                }
               }*/

                />



            </DataTable>
        </MainLayout>
    );

};